<template>
  <div class="box">
    <div class="box-header">
      PDF versions
      <button
        v-if="comparableCount >= 2"
        class="compare-button"
        @click="showCompare = true"
      >
        <i class="mdi mdi-compare-horizontal"></i> Compare versions
      </button>
    </div>
    <OrderVersionsCompareModal
      v-if="showCompare"
      :show="showCompare"
      :order-number="versions[0].orderNumber"
      :versions="versions"
      @close="showCompare = false"
    />
    <div class="content">
      <!-- Empty state -->
      <div v-if="versions.length === 0" class="empty-state">
        <i class="mdi mdi-file-pdf-box"></i>
        <p>No PDF versions yet</p>
      </div>
      <!-- Versions table -->
      <div v-else class="table-scroll">
        <table class="default-table versions-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Message</th>
              <th style="width: 170px">Date</th>
              <th>Admin name</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="version in versions" :key="version.id">
              <td class="version-action">
                <span class="action-type">{{ version.actionType }}</span>
              </td>
              <td class="version-message">
                {{ version.actionMessage }}
              </td>
              <td class="version-date">
                {{ version.date | dateWithHours }}
              </td>
              <td class="version-admin">
                {{ version.adminName }}
              </td>
              <td class="version-link">
                <a
                  target="_blank"
                  :href="versionUrl(version)"
                  class="open-link"
                  title="Open PDF"
                >
                  <i class="mdi mdi-open-in-new"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { resolveStoreApiUrl } from "@/utils/store-api-url";
import OrderVersionsCompareModal from "./OrderVersionsCompareModal.vue";

export default {
  name: "OrderVersions",
  components: {
    OrderVersionsCompareModal
  },
  props: {
    versions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showCompare: false
    };
  },
  computed: {
    // Sólo las versiones con snapshot (las nuevas) se pueden comparar.
    comparableCount() {
      return this.versions.filter(version => version.snapshotId).length;
    }
  },
  methods: {
    versionUrl(version) {
      return resolveStoreApiUrl(
        version.invoiceUrl,
        this.$store.getters["general/getActiveStore"].endpoint
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

// El encabezado es blanco dentro del modal de orden: mismo acento que .open-link.
.compare-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid rgba(18, 110, 106, 0.3);
  border-radius: 6px;
  background: white;
  color: #126e6a;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;

  i {
    font-size: 16px;
  }

  &:hover {
    background: rgba(18, 110, 106, 0.08);
  }
}

.table-scroll {
  overflow-x: auto;
}

/* Movil: lista en vez de tabla (con table-layout fixed del modal de orden
   las columnas quedaban de ~37px). Arriba accion y PDF, luego el mensaje y
   al final fecha y admin. !important: le gana a las reglas de tabla del
   modal de orden */
@media (max-width: 767px) {
  .table-scroll {
    overflow-x: visible;
  }

  .versions-table,
  .versions-table tbody {
    display: block;
  }

  .versions-table thead {
    display: none;
  }

  .versions-table tr {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f3f4f6;
  }

  .versions-table td {
    display: block;
    width: auto !important;
    padding: 0 !important;
    border: none !important;
  }

  .versions-table td:empty {
    display: none;
  }

  .versions-table .version-link {
    order: 1;
    margin-left: auto;
  }

  .versions-table .version-message {
    flex: 1 0 100%;
    order: 2;
    color: #111827;
  }

  .versions-table .version-date,
  .versions-table .version-admin {
    order: 3;
    font-size: 14px;
    color: #6b7280;
  }
}

.action-type {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.version-date {
  white-space: nowrap;
  color: #6b7280;
}

.open-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: #126e6a;

  i {
    font-size: 18px;
  }

  &:hover {
    background: rgba(18, 110, 106, 0.08);
  }
}
</style>
